import type { TenantWorkScheduleDto, MemberWorkScheduleDto } from '../types';

/**
 * Mutable mock store for USE_MOCK mode.
 *
 * @remarks
 * Mutations mutate these in place so subsequent reads reflect changes,
 * making the UI testable end-to-end without a backend.
 */
export const tenantWorkScheduleMock: TenantWorkScheduleDto = {
  tenantId: 'mock-tenant',
  hoursPerDay: 8,
  workingDays: 5,
  isDefault: false,
  segments: [{ order: 0, startTime: '09:00', endTime: '17:00' }],
};

export const memberWorkSchedulesMock: MemberWorkScheduleDto[] = [
  {
    tenantId: 'mock-tenant',
    userId: '1001',
    hoursPerDay: 6,
    createdAt: '2026-05-02T09:00:00Z',
    updatedAt: '2026-06-10T14:30:00Z',
    segments: [{ order: 0, startTime: '09:00', endTime: '15:00' }],
  },
  {
    tenantId: 'mock-tenant',
    userId: '1002',
    hoursPerDay: 4,
    createdAt: '2026-04-18T08:15:00Z',
    updatedAt: null,
    segments: [{ order: 0, startTime: '09:00', endTime: '13:00' }],
  },
  {
    tenantId: 'mock-tenant',
    userId: '1003',
    hoursPerDay: 10,
    createdAt: '2026-06-01T11:45:00Z',
    updatedAt: '2026-06-15T16:20:00Z',
    segments: [
      { order: 0, startTime: '08:00', endTime: '13:00' },
      { order: 1, startTime: '14:00', endTime: '19:00' },
    ],
  },
];
